<template>
    <div>
        <svg version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
             y="0px" viewBox="0 0 129.4 47.3" xml:space="preserve">
<g id="weingut" class="shape" :class="{visible : shapes.weingut.isVisible}">
	<g>
		<path fill="#1D1D1B" d="M39.8,47l-1.6-7.4c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0.3c0.1,0,0.2,0.1,0.2,0.2
			c0,0,0,0,0,0l1.3,6.5c0,0,0,0.1,0.1,0.1l0,0c0,0,0.1,0,0.1-0.1l1.3-6.5c0-0.1,0.1-0.2,0.2-0.2h0.4c0.1,0,0.2,0.1,0.2,0.2l1.2,6.5
			c0,0,0,0.1,0.1,0.1l0,0c0,0,0.1,0,0.1-0.1l1.3-6.5c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0.3c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0
			c0,0.1,0,0.1,0,0.2L44.3,47c0,0.1-0.1,0.2-0.2,0.2h-0.6c-0.1,0-0.2-0.1-0.2-0.2l-1.2-6c0-0.1,0-0.1,0-0.1s0,0-0.1,0.1l-1.2,6
			c0,0.1-0.1,0.2-0.2,0.2H40C39.9,47.2,39.8,47.1,39.8,47z"/>
        <path fill="#1D1D1B" d="M49.2,47v-7.5c0-0.1,0.1-0.2,0.2-0.2H53c0.1,0,0.2,0.1,0.2,0.2v0.3c0,0.1-0.1,0.2-0.2,0.3c0,0,0,0,0,0h-3
			c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0v2.6c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0h2.9c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0v0.3
			c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0h-2.8c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0v2.8c0,0.1,0,0.1,0.1,0.1c0,0,0,0,0,0h3
			c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0V47c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0h-3.6C49.3,47.2,49.2,47.1,49.2,47
			C49.2,47,49.2,47,49.2,47z"/>
        <path fill="#1D1D1B" d="M56.8,47v-7.5c0-0.1,0.1-0.2,0.2-0.2h0.3c0.1,0,0.2,0.1,0.2,0.2V47c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0H57
			C56.9,47.2,56.8,47.1,56.8,47z"/>
        <path fill="#1D1D1B" d="M61.5,47v-7.5c0-0.1,0.1-0.2,0.2-0.2h0.6c0.1,0,0.2,0,0.2,0.2l2.7,6.5c0,0,0,0,0.1,0c0,0,0,0,0,0v-6.5
			c0-0.1,0.1-0.2,0.2-0.2h0.2c0.1,0,0.2,0.1,0.2,0.2v0V47c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0h-0.6c-0.1,0-0.2,0-0.2-0.2l-2.7-6.5
			 M62.1,40.5V47c0,0.1-0.1,0.2-0.2,0.2h-0.2c-0.1,0-0.2-0.1-0.2-0.2L62.1,40.5z"/>
        <path fill="#1D1D1B" d="M70,45.8c-0.3-0.8-0.4-1.7-0.3-2.6c-0.1-0.9,0.1-1.7,0.3-2.6c0.4-0.9,1.3-1.6,2.4-1.5
			c1.3-0.1,2.4,0.8,2.5,2.1c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.2,0.2l0,0h-0.3c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0
			c0-0.9-0.7-1.6-1.5-1.6c-0.1,0-0.1,0-0.2,0c-0.8,0-1.5,0.4-1.7,1.2c-0.2,0.7-0.3,1.5-0.2,2.2c0,0.8,0,1.5,0.2,2.2
			c0.3,0.7,0.9,1.1,1.7,1.1c0.9,0.1,1.7-0.6,1.7-1.5c0-0.1,0-0.2,0-0.3v-1.1c0-0.1-0.1-0.1-0.1-0.1l0,0h-1.3c-0.1,0-0.2-0.1-0.2-0.2
			c0,0,0,0,0,0v-0.3c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h2c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0v1.7c0.1,1.3-0.8,2.4-2.1,2.6
			c-0.1,0-0.3,0-0.4,0C71.3,47.3,70.4,46.7,70,45.8z"/>
        <path fill="#1D1D1B" d="M78.4,44.9v-5.4c0-0.1,0.1-0.2,0.2-0.2h0.3c0.1,0,0.2,0.1,0.2,0.2v0v5.4c0,0.9,0.8,1.7,1.7,1.7
			s1.7-0.8,1.7-1.7v-5.4c0-0.1,0.1-0.2,0.2-0.2l0,0h0.3c0.1,0,0.2,0.1,0.2,0.2v0v5.4c0,1.4-1.1,2.5-2.5,2.5
			C79.5,47.3,78.4,46.2,78.4,44.9z"/>
        <path fill="#1D1D1B" d="M88.5,47v-6.9c0-0.1,0-0.1-0.1-0.1c0,0,0,0,0,0h-1.7c-0.1,0-0.2-0.1-0.2-0.2c0,0,0,0,0,0v-0.3
			c0-0.1,0.1-0.2,0.2-0.2H91c0.1,0,0.2,0.1,0.2,0.2v0v0.3c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0h-1.7c-0.1,0-0.1,0.1-0.1,0.1l0,0V47
			c0,0.1-0.1,0.2-0.2,0.2l0,0h-0.3C88.6,47.2,88.5,47.1,88.5,47z"/>
	</g>
</g>
            <g id="logo-r" class="shape" :class="{visible : shapes.r.isVisible}">
	<path fill="#1D1D1B" d="M126.8,8.6c0-4.9-2.8-7.6-8-7.6h-8.1v26.3h5.2V16h2.3l5.6,11.2h5.6l-6.3-12.2
		C125.6,13.8,127,11.3,126.8,8.6 M118.4,5.6c1.5-0.1,2.9,1,3,2.5c0,0.2,0,0.3,0,0.5c0.2,1.6-1,2.9-2.5,3.1c-0.2,0-0.3,0-0.5,0h-2.5
		V5.6H118.4z"/>
</g>
            <g id="logo-e" class="shape" :class="{visible : shapes.e.isVisible}">
	<polygon fill="#1D1D1B" points="103.9,27.3 103.9,22.4 97.1,22.4 97.1,16.3 103.6,16.3 103.6,11.4 97.1,11.4 97.1,6 103.8,6
		103.8,1 91.8,1 91.8,27.3 	"/>
</g>
            <g id="logo-l" class="shape" :class="{visible : shapes.l.isVisible}">
	<polygon fill="#1D1D1B" points="85.5,27.3 85.5,22.4 78.8,22.4 78.8,1 73.6,1 73.6,27.3 	"/>
</g>
            <g id="logo-f" class="shape" :class="{visible : shapes.f.isVisible}">
	<polygon fill="#1D1D1B" points="66.7,16.3 66.7,11.4 60,11.4 60,6 66.9,6 66.9,1 54.8,1 54.8,27.3 60,27.3 60,16.3 	"/>
</g>
            <g id="logo-oe" class="shape" :class="{visible : shapes.oe.isVisible}">
	<path fill="#1D1D1B" d="M34.3,5.5c1.6,0,2.8-1.2,2.8-2.8c0,0,0,0,0,0c-0.1-1.6-1.4-2.7-3-2.7c-1.4,0.1-2.6,1.2-2.7,2.7
		c0,1.5,1.2,2.8,2.7,2.8C34.3,5.5,34.3,5.5,34.3,5.5 M41.3,5.5c1.6,0,2.8-1.2,2.9-2.8c0,0,0,0,0-0.1c-0.1-1.6-1.4-2.7-3-2.7
		c-1.4,0.1-2.6,1.2-2.7,2.7C38.5,4.2,39.7,5.5,41.3,5.5C41.2,5.5,41.3,5.5,41.3,5.5 M32.4,17.1c0-3.4,2.2-5.9,5.5-5.9
		s5.5,2.5,5.5,5.9S41.2,23,37.9,23S32.4,20.5,32.4,17.1 M27.3,17.1c0,6,4.2,10.4,10.6,10.4c5.6,0.2,10.4-4.2,10.6-9.8
		c0-0.2,0-0.4,0-0.6c0-6-4.2-10.5-10.6-10.5c-5.7-0.2-10.4,4.3-10.6,10C27.3,16.8,27.3,17,27.3,17.1"/>
</g>
            <g id="logo-h" class="shape" :class="{visible : shapes.h.isVisible}">
	<polygon fill="#1D1D1B" points="21,1 15.8,1 15.8,11.3 5.3,11.3 5.3,1 0,1 0,27.3 5.3,27.3 5.3,16.3 15.8,16.3 15.8,27.3 21,27.3
		"/>
</g>
</svg>
    </div>
</template>

<script>
  export default {
    name: 'logo',
    timers: {
      showH:        { time: 200, autostart: true, repeat: false},
      showOe:       { time: 350, autostart: true, repeat: false},
      showF:        { time: 500, autostart: true, repeat: false},
      showL:        { time: 650, autostart: true, repeat: false},
      showE:        { time: 800, autostart: true, repeat: false},
      showR:        { time: 950, autostart: true, repeat: false},
      showWeingut:  { time: 400, autostart: true, repeat: false},
    },
    data() {
      return {
        loaded: false,
        shapes: {
          h: {
            isVisible: false,
          },
          oe: {
            isVisible: false,
          },
          f: {
            isVisible: false,
          },
          l: {
            isVisible: false,
          },
          e: {
            isVisible: false,
          },
          r: {
            isVisible: false,
          },
          weingut: {
            isVisible: false,
          },
        },
      }
    },
    mounted() {
    },
    updated() {
    },
    created() {
    },
    destroyed() {
    },
    methods: {
      showH() {
        this.shapes.h.isVisible = true;
      },
      showOe() {
        this.shapes.oe.isVisible = true;
      },
      showF() {
        this.shapes.f.isVisible = true;
      },
      showL() {
        this.shapes.l.isVisible = true;
      },
      showE() {
        this.shapes.e.isVisible = true;
      },
      showR() {
        this.shapes.r.isVisible = true;
      },
      showWeingut() {
        this.shapes.weingut.isVisible = true;
      }
    }
  }
</script>


<style lang="scss" scoped>
    .shape {
        visibility: hidden;
        opacity: 0;
        transition: opacity .8s, visibility .8s ease-in-out;
        polygon,
        path {
            fill: #FFFFFF;
        }
    }

    #weingut {
        transition: opacity 1s, visibility 1s ease-in;
    }

    .visible {
        visibility: visible;
        opacity: 1;
    }

</style>
